import React from 'react';

export default function Pager({ page, size, total, onPage }) {
  const pages = Math.max(1, Math.ceil(total / size));
  return (
    <div className="pager">
      <button className="btn btn-small" disabled={page <= 0} onClick={() => onPage(page - 1)}>‹ Înapoi</button>
      <span className="muted small">Pagina {page + 1} din {pages} · {total} rezultate</span>
      <button className="btn btn-small" disabled={page + 1 >= pages} onClick={() => onPage(page + 1)}>Înainte ›</button>
    </div>
  );
}
